import Layout from '#GameFrontend/authorized/components/Layout';
import Main from '#GameFrontend/authorized/pages/Main';
import { BankProvider } from '#GameFrontend/contexts/BankContext';
import { FilterProvider } from '#GameFrontend/contexts/FilterContext';
import { GameConfigProvider } from '#GameFrontend/contexts/GameConfigContext';
import { LoadingProvider } from '#GameFrontend/contexts/LoadingContext';
import React, { Suspense, lazy } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './styles/fonts.css';
import './styles/globals.scss';
import './styles/sprites.scss';

const HorseList = lazy(() => import('#GameFrontend/authorized/pages/horse/List'));
const HorseView = lazy(() => import('#GameFrontend/authorized/pages/horse/View'));
const BankIndex = lazy(() => import('#GameFrontend/authorized/pages/bank/Index'));
const BankCando = lazy(() => import('#GameFrontend/authorized/pages/bank/Cando'));
const BankHorseshoe = lazy(() => import('#GameFrontend/authorized/pages/bank/Horseshoe'));

const Authorized: React.FC = () => {
	return (
		<Router>
			<LoadingProvider>
				<GameConfigProvider>
					<BankProvider>
						<FilterProvider>
							<div className="authorized-layout">
								<Suspense fallback={<div>Loading...</div>}>
									<Routes>
										<Route path="/" element={<Layout />}>
											<Route index element={<Main />} />
											<Route path="horse/list" element={<HorseList />} />
											<Route path="horse/view/:id" element={<HorseView />} />
											<Route path="bank" element={<BankIndex />} />
											<Route path="bank/cando" element={<BankCando />} />
											<Route path="bank/horseshoe" element={<BankHorseshoe />} />
										</Route>
									</Routes>
								</Suspense>
							</div>
						</FilterProvider>
					</BankProvider>
				</GameConfigProvider>
			</LoadingProvider>
		</Router>
	);
};

export default Authorized;
